import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import SkipLogic from "./logicComponents/SkipLogic";
import ExtractionLogic from "./logicComponents/ExtractionLogic";

const LogicOptions = [{ name: "Skip Logic", value: "skip_logic" }];

const LogicDialog = (props) => {
  const {
    isSLDialogVisible,
    setIsSLDialogVisible,
    taskQuestions,
    setSelectedTQIndex,
    selectedTQIndex,
    selectedChildQuesIndex = null,
    isSubQuestion = false,
    handleSaveExtractionLogic = () => {},
  } = props;

  const [selectedTQ] = useState(
    isSubQuestion
      ? taskQuestions[selectedTQIndex]?.subTaskQues[selectedChildQuesIndex]
      : taskQuestions[selectedTQIndex],
  );
  const selectedTQType = selectedTQ?.type || "";
  const [selectedLogicType, setSelectedLogicType] = useState("skip_logic");
  const [logicOptions, setLogicOptions] = useState(LogicOptions);

  useEffect(() => {
    if (
      !isSubQuestion &&
      !selectedTQ?.isExtraction &&
      selectedTQ?.selectedQuestionOption === "multiple_choice_multi_select"
    ) {
      setLogicOptions((prev) => [
        ...prev,
        { name: "Extraction Logic", value: "extraction_logic" },
      ]);
    }

    if (selectedTQ?.isExtraction) {
      setSelectedLogicType("extraction_logic");
      setLogicOptions([
        { name: "Extraction Logic", value: "extraction_logic" },
      ]);
    }
  }, []);

  return (
    <Dialog
      header="Logic"
      position={"top"}
      visible={isSLDialogVisible}
      style={{ width: "65vw" }}
      onHide={() => {
        if (!isSLDialogVisible) return;
        setIsSLDialogVisible(false);
        setSelectedTQIndex(null);
      }}
      blockScroll
      className="skip-logic-modal"
    >
      <div className="m-0 pt-4">
        <div className="text_dark task-question-heading">Task/Question:</div>

        <div className="text_dark fw-600 mt-2">
          {selectedTQType === "task"
            ? `Task: ${selectedTQ.taskName || ""}`
            : `Question: ${selectedTQ?.questionName || ""}`}
        </div>

        <div className="col-md-2 col-6 mt-4">
          <Dropdown
            value={selectedLogicType}
            onChange={(e) => {
              setSelectedLogicType(e.value);
            }}
            options={logicOptions}
            optionLabel="name"
            placeholder="Skip Logic"
            className="w-100 inputField"
          />
        </div>

        {selectedLogicType === "skip_logic" && <SkipLogic {...props} />}

        {selectedLogicType === "extraction_logic" && (
          <ExtractionLogic
            {...props}
            handleSaveExtractionLogic={handleSaveExtractionLogic}
            isExtractionQuestion={selectedTQ?.isExtraction || false}
            selectedTQ={selectedTQ}
          />
        )}
      </div>
    </Dialog>
  );
};

export default LogicDialog;
